'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Contact = void 0;
var $ = require("jquery");
var Contact = /** @class */ (function () {
    function Contact() {
        // PCより大きいサイズ
        this.overPcWidth = 1200;
        var self = this;
        $('#trigContactForm').on('click', function () {
            $('.bulletError').hide();
            self.getValues();
            if (self.validates()) {
                self.moveFormTop();
                return false;
            }
        });
    }
    Contact.prototype.getValues = function () {
        this.category = $('[name=your_category] option:selected').val();
        this.name = $('#name').val();
        this.kana = $('#kana').val();
        this.email = $('#email').val();
        this.inquiry = $('#inquiry').val();
        this.accept = $('[name=your_accept]:checked').val();
    };
    Contact.prototype.validates = function () {
        var errorFlag = false;
        this.errorName = "";
        if (!this.checkNull(this.category)) {
            errorFlag = true;
            $('#bulletErrorCategory').show();
            this.errorName = 'paramFormCategory';
        }
        if (!this.checkNull(this.name)) {
            errorFlag = true;
            $('#bulletErrorName').show();
            if (this.errorName == "") {
                this.errorName = 'paramFormName';
            }
        }
        if (!this.checkNull(this.kana)) {
            errorFlag = true;
            $('#bulletErrorKana').show();
            if (this.errorName == "") {
                this.errorName = 'paramFormKana';
            }
        }
        else if (!this.kanaZenkakuCheck(this.kana)) {
            errorFlag = true;
            $('#bulletErrorKanaZenkaku').show();
            if (this.errorName == "") {
                this.errorName = 'paramFormKana';
            }
        }
        if (!this.checkNull(this.email)) {
            errorFlag = true;
            $('#bulletErrorEmail').show();
            if (this.errorName == "") {
                this.errorName = 'paramFormEmail';
            }
        }
        else if (!this.emailFormatCheck(this.email)) {
            errorFlag = true;
            $('#bulletErrorEmailFormat').show();
            if (this.errorName == "") {
                this.errorName = 'paramFormEmail';
            }
        }
        if (!this.checkNull(this.inquiry)) {
            errorFlag = true;
            $('#bulletErrorInquiry').show();
            if (this.errorName == "") {
                this.errorName = 'paramFormInquiry';
            }
        }
        if (!this.checkNull(this.accept)) {
            errorFlag = true;
            $('#bulletErrorAccept').show();
            if (this.errorName == "") {
                this.errorName = 'paramFormAccept';
            }
        }
        return errorFlag;
    };
    Contact.prototype.moveFormTop = function () {
        var headerHeight = $('.paramFixedHeader').outerHeight();
        var errorPosition = $('.' + this.errorName).offset().top;
        var adjustParam = 20;
        $('html, body').animate({
            scrollTop: errorPosition - headerHeight - adjustParam
        }, 'slow');
    };
    Contact.prototype.checkNull = function (val) {
        return this.removeSpace(val) != '';
    };
    // 空白文字の削除
    Contact.prototype.removeSpace = function (val) {
        if (val) {
            return val.replace(/\s+/g, '');
        }
        else {
            return '';
        }
    };
    // 電話番号のフォーマットチェック
    Contact.prototype.telFormatCheck = function (val) {
        return val.match(/[0-9]{2,4}[\-]{0,1}[0-9]{2,4}[\-]{0,1}[0-9]{2,4}/);
    };
    // メールのフォーマットチェック
    Contact.prototype.emailFormatCheck = function (val) {
        return val.match(/^[0-9a-zA-Z]+[0-9a-zA-Z\-\+_\.]+@[0-9a-zA-Z\-\+_\.]+\.[0-9a-zA-Z\-\+_\.]+$/g);
    };
    // 全角カナのチェック
    Contact.prototype.kanaZenkakuCheck = function (val) {
        val = (val === null) ? "" : val;
        if (val.match(/^[ァ-ヶー　]*$/)) {
            return true;
        }
        else {
            return false;
        }
    };
    return Contact;
}());
exports.Contact = Contact;
exports.default = Contact;
